import { useState } from 'react';
import { cn } from '~/util';
import { useFieldContext } from '~/util/hooks/useFormContext';
import { BaseLevel } from '~/util/types/levels';
import {
    FieldLabelWithError,
    FieldWithErrorProps,
} from './FieldLabelWithError';
import { useDisableFormContext } from '../DisableContext';
import { InteractableDataWrapper } from '~/partials/InteractableDataWrapper';
import { Dialog, DialogContent, DialogTitle } from '~/primitives/dialog';
import ColorPicker from 'react-best-gradient-color-picker';

export function ColorField({
    placeholder,
    classname,
    forceDisabled,
    ...labelProps
}: {
    placeholder?: string;
    forceDisabled?: boolean;
    classname?: string;
} & FieldWithErrorProps) {
    const field = useFieldContext<string | null>();
    const [colorSelectorOpen, setColorSelectorOpen] = useState(false);
    const disabled = useDisableFormContext() || forceDisabled;
    return (
        <FieldLabelWithError<BaseLevel | null> {...labelProps}>
            <InteractableDataWrapper
                id={field.name}
                required={labelProps.required}
                disabled={disabled}
                open={colorSelectorOpen}
                className={cn(
                    'p-0 bg-transparent hover:bg-transparent',
                    classname,
                    disabled && 'opacity-50',
                )}
                onClick={() => {
                    if (!disabled) setColorSelectorOpen(true);
                }}
            >
                <div
                    className={cn(
                        'h-6 rounded-sm',
                        (field.state.value || !placeholder) && 'w-16',
                    )}
                    style={{
                        background: field.state.value ?? '#000000',
                    }}
                >
                    {field.state.value || !placeholder ? '' : placeholder}
                </div>
            </InteractableDataWrapper>
            <Dialog
                open={colorSelectorOpen}
                onOpenChange={setColorSelectorOpen}
            >
                <DialogContent className="w-fit" aria-describedby={undefined}>
                    <DialogTitle>Select color</DialogTitle>
                    <div className="flex flex-col items-start">
                        <ColorPicker
                            value={field.state.value ?? '#000000'}
                            onChange={field.handleChange}
                        />
                    </div>
                </DialogContent>
            </Dialog>
        </FieldLabelWithError>
    );
}
